import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useFetching = fetchActionCreator => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchActionCreator());
  }, []);
};

export const usePermissions = permission => {
  const userPermissions = useSelector(x => x.userState.permissions);
  return useMemo(() => userPermissions.includes(permission.value), [permission, userPermissions]);
};



// WEBPACK FOOTER //
// ./src/hooks/redux.js